export const routes = {
  home: 'home',
  about: 'about',
  contact: 'contact',
  catalogue: 'catalogue',
  products: 'products',
  services: 'services'
};
